/* eslint-disable import/prefer-default-export */
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const COMMAND = project.getFeature(feature.getSettingValue('COMMAND'));
    if (!COMMAND) {
        return blocks;
    }

    const links = project.getNodeLinks(feature, 'on_command_triggered');
    if (links.length > 0) {
        const link = links[0];
        const commandName = COMMAND.getSettingValue('NAME');
        blocks.push({
            location: `cmd_${commandName}`,
            blockType: BlockType.CODE,
            id: feature.getID(),
            template: `/****${link.getSourceId()}****/`,
        });
    }

    return blocks;
};
